import { Address } from "common/event/event.types";
import { values, isEmpty, filter } from "lodash-es";

export const COMMA_AND_SPACE = ", ";
export const SPACE = " ";

const getPartOneOfAddressFormatted = (address: Address): string => {
  const addressFormatted = {
    venueName: address.venueName,
    street1: address.street1,
    street2: address.street2,
    street3: address.street3,
  };
  const addressValues = filter(values(addressFormatted), (address) => !isEmpty(address));
  return isEmpty(addressValues) ? "" : addressValues.join(COMMA_AND_SPACE);
};

const getPartTwoOfAddressFormatted = (address: Address): string => {
  const addressFormatted = {
    zipCode: address.zipCode,
    city: address.city,
    country: address.country.name,
  };
  const addressValues = filter(values(addressFormatted), (address) => !isEmpty(address));
  return isEmpty(addressValues) ? "" : addressValues.join(SPACE);
};

export const getAddressFormatted = (address: Address): string => {
  if (!address) {
    return "";
  }

  const firstPart = getPartOneOfAddressFormatted(address);
  const secondPart = getPartTwoOfAddressFormatted(address);

  return !isEmpty(firstPart) ? `${firstPart}, ${secondPart}` : `${secondPart}`;
};

export const isAddressComplete = (address: Address): boolean => {
  return Boolean(
    address &&
    address.city &&
    address.country &&
    address.country.name &&
    (address.venueName || address.street1 || address.street2 || address.street3)
  );
};
